// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchTitle-module_root_3mwIP","wrapper":"SearchTitle-module_wrapper_yEmih","title":"SearchTitle-module_title_1uQzF","contextLinks":"SearchTitle-module_contextLinks_1t7A1"};